import { Component } from '@angular/core';

@Component({
  selector: 'll-exam-sections-bbc',
  templateUrl: './ll-exam-sections-bbc.component.html',
  styleUrl: './ll-exam-sections-bbc.component.css'
})
export class LlExamSectionsBBCComponent {

}
